var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2034_4395",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.325684,
    y: 0.843506,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2034_4395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3257 21.5686V19.5186C15.8257 19.0853 17.034 18.2519 17.9507 17.0186C18.8674 15.7853 19.3257 14.3853 19.3257 12.8186C19.3257 11.2519 18.8674 9.85194 17.9507 8.6186C17.034 7.38527 15.8257 6.55194 14.3257 6.1186V4.0686C16.3924 4.53527 18.0757 5.5811 19.3757 7.2061C20.6757 8.8311 21.3257 10.7019 21.3257 12.8186C21.3257 14.9353 20.6757 16.8061 19.3757 18.4311C18.0757 20.0561 16.3924 21.1019 14.3257 21.5686ZM3.32568 15.8436V9.8436H7.32568L12.3257 4.8436V20.8436L7.32568 15.8436H3.32568ZM14.3257 16.8436V8.7936C15.109 9.16027 15.7215 9.71027 16.1632 10.4436C16.6049 11.1769 16.8257 11.9769 16.8257 12.8436C16.8257 13.6936 16.6049 14.4811 16.1632 15.2061C15.7215 15.9311 15.109 16.4769 14.3257 16.8436ZM10.3257 9.6936L8.17568 11.8436H5.32568V13.8436H8.17568L10.3257 15.9936V9.6936Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume_up.1584d77e143ff05315c1ac4e83edde79.svg";
export { ForwardRef as ReactComponent };